import { PageTitle } from 'components/common/PageTitle/PageTitle';
import 'styles/sass/employees/employees-list.scss';
import 'styles/sass/tables.scss';
import { MissingSchedulesAlert } from './components/MissingSchedulesAlert';
import { UserListToolbar } from './components/UserListToolbar';
import { UserTable } from './components/UserTable';
import { useUserList } from './hooks/useUserList';
import { useUserListActions } from './hooks/useUserListActions';

const UserListPage = () => {
  const userList = useUserList();
  const actions = useUserListActions();

  return (
    <div id="employees-list">
      <PageTitle>Lista de empleados</PageTitle>
      <h2 className="title" data-test-id="employee-list">
        Lista de empleados
      </h2>
      <UserListToolbar
        exportContractsLoading={actions.exportContractsLoading}
        onAddEmployee={actions.onAddEmployee}
        onBulkReconcileIncidences={actions.onBulkReconcileIncidences}
        onExportContracts={actions.onExportContracts}
        onRoleFilterChange={userList.setRoleFilter}
        onSearchChange={userList.setSearchValue}
        onShowInactiveUsersChange={userList.setShowInactiveUsers}
        onUploadContracts={actions.onUploadContracts}
        onUploadEmployees={actions.onUploadEmployees}
        onUploadPhotos={actions.onUploadPhotos}
        roleFilter={userList.roleFilter}
        searchValue={userList.searchValue}
        showInactiveUsers={userList.showInactiveUsers}
      />
      <MissingSchedulesAlert
        activeContractsCount={userList.activeContractsWithoutSchedulesCount}
        onShowMissingScheduleUsersChange={userList.setShowMissingScheduleUsers}
        showMissingScheduleUsers={userList.showMissingScheduleUsers}
      />
      <UserTable
        actions={actions.rowActions}
        activeContractUserIds={userList.activeContractUserIds}
        impersonatingEmployeeId={actions.impersonatingEmployeeId}
        loading={userList.loading}
        users={userList.filteredUsers}
      />
    </div>
  );
};

export default UserListPage;
